import styled from 'styled-components';

export const ActionsLimitTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionsLimitLoading = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  .ant-spin,
  .ant-spin-dot {
    background: transparent;
  }

  .actions-limit-loading-text {
    max-width: 220px;
    line-height: 1.1rem;
    color: ${({ theme }) => theme?.colors?.text1};
  }
`;

export const ActionsLimitContent = styled.div`
  width: 100%;
  display: grid;
  place-items: center;
  padding: 24px;
  background: ${({ theme }) => theme?.colors?.background1};
  border: solid 1px ${({ theme }) => theme?.colors?.border};
  border-radius: ${({ theme }) => theme?.shapes?.borderRadius};
`;

export const ActionsLimitAvailable = styled.div`
  text-align: center;

  .ant-tag {
    padding: 8px 16px;
    font-size: 1.1rem;
    background: ${({ theme }) => theme?.colors?.content} !important;
  }
`;
